import ApiService from '../../../services/ApiService';

export default {
  async loadUserRoles(context) {
    const response = await ApiService.fetchUserRoles();
    const userRoles = await response.data;
    context.commit('setUserRoles', userRoles);
  },
};
